import { ca } from '@cian/analytics';
import { EAnchorBlock } from '../../repositories/price-estimator/entities/onboardings/TooltipSchema';

export function trackViewOnbordingBanner() {
  ca('teaser', {
    product: {
      name: 'onboarding',
    },
  });
}

export function trackOnbordingItemClick(place: EAnchorBlock | string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    label: 'Onboarding',
    action: 'Click_sopr',
    page: {
      extra: {
        place,
      },
    },
  });
}

export function trackOnbordingCloseClick(place: EAnchorBlock | string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    label: 'OnboardingClose',
    action: 'Click_sopr',
    page: {
      extra: {
        place,
      },
    },
  });
}
